var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 900,
    height: 11,
    viewBox: "0 0 900 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 10L746 10",
    stroke: "#747373",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_325)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.001 3.34897e-07L769.501 1.14724e-05L753.501 10L746.001 10",
    stroke: "#747373",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M762.306 9.5L770.639 4.5H778.696L770.362 9.5H762.306Z",
    stroke: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M779.306 9.5L787.639 4.5H795.696L787.362 9.5H779.306Z",
    stroke: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.306 9.5L804.639 4.5H812.696L804.362 9.5H796.306Z",
    stroke: "#7D7C7C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.501 4H900.001V7H859.001L855.751 10H811.501L821.501 4Z",
    fill: "#7D7C7C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_179_325"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154,
    height: 11,
    fill: "white",
    transform: "translate(746.001)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLine);
export default __webpack_public_path__ + "static/media/footerLine.4b6b935eb182a14868cd9d74ed639c66.svg";
export { ForwardRef as ReactComponent };